<template>
  <v-app-bar
    app
    color="primary"
    dark
  >
    <v-app-bar-nav-icon @click="menuNav ? hideMenuNav() : showMenuNav()"></v-app-bar-nav-icon>
    <div class="d-flex align-center">
      <b style="white-space: nowrap">ЛК</b>
      <span class="mx-5">{{ getTranslateRouteName() }}</span>
    </div>
    <v-spacer></v-spacer>
    <wallet-badge v-if="isLogged"/>
    <v-spacer></v-spacer>
    <v-btn text x-small class="mr-5" @click="changeLang">
      {{language}}
    </v-btn>
    <span class="mr-2">{{ user && (user.name || user.login) }}</span>
    <v-btn v-if="!!user" icon @click="logOut">
      <v-icon>mdi-open-in-new</v-icon>
    </v-btn>
  </v-app-bar>
</template>

<script>
import { config } from '@/config'
import { authService } from '@/services/AuthService'
import router from '@/router'
import { mapGetters, mapActions } from 'vuex'
import WalletBadge from '@/components/WalletBadge.vue'

export default {
  components: {
    WalletBadge
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters(['user', 'isLogged', 'menuNav', 'language']),
    updateTimeSec () {
      return config.updateTimeSec
    }
  },
  methods: {
    ...mapActions(['showMenuNav', 'hideMenuNav', 'setRuLanguage', 'setEnLanguage']),
    logOut () {
      authService.logout()
      router.go()
    },
    changeLang () {
      if (this.language === 'ru') {
        this.setEnLanguage()
        this.$i18n.locale = 'en'
        return
      }
      if (this.language === 'en') {
        this.setRuLanguage()
        this.$i18n.locale = 'ru'
      }
    },
    getTranslateRouteName () {
      const name = this.$route.name ? (this.$t('route.' + this.$route.name)).toUpperCase() : ''
      return name
    }
  }
}
</script>

<style scoped>

</style>
